import { c as _c } from "react/compiler-runtime";
import DoneIcon from "@mui/icons-material/Done";

// Shared chip components rendered by both the mobile FilterSheet (bottom
// sheet) and the desktop FiltersSidebar (persistent left column) so the two
// surfaces stay visually identical.

export const FilterOptionButton = t0 => {
  const $ = _c(9);
  const {
    option,
    isSelected,
    onClick
  } = t0;
  const t1 = `px-3 py-[6px] flex items-center justify-between gap-2 transition-colors ${isSelected ? "bg-[--colorSecondarySecondaryContainer] rounded-full" : "border border-[--colorOutlineOutline] rounded-lg"}`;
  let t2;
  if ($[0] !== option) {
    t2 = <span className="m3-label-large text-[--textSecondarySecondary]">{option}</span>;
    $[0] = option;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isSelected) {
    t3 = isSelected && <DoneIcon sx={{
      fontSize: 18,
      color: "var(--colorPrimaryOnPrimaryContainer)"
    }} />;
    $[2] = isSelected;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClick || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <button onClick={onClick} className={t1}>{t2}{t3}</button>;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const FilterSection = t0 => {
  const $ = _c(16);
  const {
    title,
    options,
    selectedValues,
    category,
    toggleFilter
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="m3-title-small text-[--textPrimaryPrimary] py-4">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== category || $[3] !== options || $[4] !== selectedValues || $[5] !== toggleFilter) {
    let t3;
    if ($[7] !== category || $[8] !== selectedValues || $[9] !== toggleFilter) {
      t3 = option => {
        const isSelected = selectedValues.includes(option);
        return <FilterOptionButton key={option} option={option} isSelected={isSelected} onClick={() => toggleFilter(category, option)} />;
      };
      $[7] = category;
      $[8] = selectedValues;
      $[9] = toggleFilter;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = options.map(t3);
    $[2] = category;
    $[3] = options;
    $[4] = selectedValues;
    $[5] = toggleFilter;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[11] !== t2) {
    t3 = <div className="flex flex-wrap gap-2">{t2}</div>;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t3) {
    t4 = <div>{t1}{t3}</div>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};